<template>
  <div class="app-header">
    <ul class="app-top-nav app-layout-left">
      <li class="app-nav-item app-flexible app-flexible-ctrl">
        <a href="javascript:;" title="" @click="toggleSideBar">
          <i v-if="sidebar.opened" class="el-icon-s-fold"></i>
          <i v-else class="el-icon-s-unfold"></i></a>
      </li>
      <li style="display: none;" class="app-nav-item app-nav-button-item" :class="activeIndex == index ? 'active' : ''"
          v-for="(moduleItem, index) in moduleList" v-if="moduleItem.children.length > 0" :key="index">
        <div @click="onClickModule(moduleItem, index)">
          <div class="app-nav-button-content">
            <!--<i class="el-icon-setting"></i>-->
            <span>{{ moduleItem.name }}</span>
          </div>
        </div>
      </li>

      <!-- 系统切换 -->
      <li class="app-nav-item system-switch">
        <span
          v-for="sys in systems"
          :key="sys.code"
          :class="['system-item', { active: currentSystem === sys.code }]"
          @click="switchSystem(sys.code)"
        >
          {{ sys.name }}
          <span v-if="currentSystem === sys.code" class="system-line"></span>
        </span>
      </li>
    </ul>
    <ul class="app-top-nav app-layout-right">
      <li class="app-nav-item app-nav-item-dropdown">
        <!-- <span>欢迎您</span>&nbsp;&nbsp;
        <router-link to="">
          <span>{{name}}</span>
        </router-link>
        <span class="loginout" @click="loginout">退出</span> -->
        <el-dropdown @command="dropdownCommand">
          <span class="el-dropdown-link">
            {{ realname || name }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <router-link to="/accountCenter">个人中心</router-link>
            </el-dropdown-item>
            <el-dropdown-item command="loginout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>
    </ul>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

export default {
  name: 'WtHeader',
  data() {
    return {
      activeIndex: 0,
      systems: [
        { code: 'systemA', name: '回收管家' },
        { code: 'systemB', name: '爱博绿' }
      ]
    }
  },
  created() {
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    onClickModule(moduleItem, index) {
      this.$store.dispatch('updateModuleItem', moduleItem)
      this.activeIndex = index
    },
    switchSystem(code) {
      this.$store.dispatch('switchSystem', code)
    },
    dropdownCommand(type) {
      if (type === 'loginout') {
        this.loginout()
      }
      if (type === 'self') {
        this.$router.push({ path: '/accountCenter' })
      }
    },
    // 退出按钮
    loginout() {
      this.$confirm('是否注销?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          location.reload()
        })
      }).catch(() => {
      })
    }
  },
  computed: {
    ...mapState({
      moduleList: state => state.auth.moduleList
    }),
    ...mapGetters([
      'sidebar',
      'avatar',
      'name',
      'realname',
      'currentSystem'
    ])
  }
}
</script>

<style scoped>
.loginout {
  padding-left: 10px;
}

.loginout:hover {
  cursor: pointer;
}

.system-switch {
  margin-left: 20px;
  font-size: 0;
}

.system-switch .system-item {
  position: relative;
  display: inline-block;
  padding: 0 20px;
  height: 60px;
  line-height: 60px;
  font-size: 16px !important;
  font-weight: bold;
  color: #333 !important;
  cursor: pointer;
  transition: all 0.3s;
}

.system-switch .system-item:hover {
  color: #1890ff !important;
}

.system-switch .system-item.active {
  color: #1890ff !important;
}

.system-switch .system-item.active .system-line {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 3px;
  background-color: #1890ff;
  border-radius: 2px;
}
</style>
